/** "Acme Foods Ltd" → "AF". Falls back to "?" for an empty/blank name. */
export const orgInitials = (name: string) =>
  name
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase() || '?';
